import { useState, useEffect } from "react";

const navItems = [
  { label: "みどり苑について", href: "#about" },
  { label: "施設・サービス", href: "#facility" },
  { label: "大切にしていること", href: "#important" },
  { label: "採用情報", href: "#recruit" },
  { label: "お問い合わせ", href: "#contact" },
];

const Header = () => {
  const [scrolled, setScrolled] = useState(false);
  const [menuOpen, setMenuOpen] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      setScrolled(window.scrollY > 60);
    };
    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  useEffect(() => {
    document.body.style.overflow = menuOpen ? "hidden" : "";
    return () => { document.body.style.overflow = ""; };
  }, [menuOpen]);

  return (
    <>
      <header
        className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${
          scrolled ? "bg-white/95 backdrop-blur-sm shadow-sm" : "bg-transparent"
        }`}
      >
        <div className="flex items-center justify-between px-6 lg:px-12 h-16 lg:h-20">
          {/* Logo */}
          <a href="/" className="flex items-center gap-2 shrink-0">
            <div className={`flex items-center gap-2 transition-colors ${scrolled ? "text-green-800" : "text-white"}`}>
              <div className="w-8 h-8 flex items-center justify-center">
                <i className="ri-leaf-line text-2xl" />
              </div>
              <div className="flex flex-col leading-none">
                <span className="text-xs font-semibold tracking-widest opacity-70">社会福祉法人</span>
                <span className="text-base font-bold tracking-wider">みどり苑</span>
              </div>
            </div>
          </a>

          {/* Desktop nav */}
          <nav className="hidden lg:flex items-center gap-8 text-sm font-medium">
            {navItems.map((item) => (
              <a
                key={item.label}
                href={item.href}
                className={`hover:text-green-600 transition-colors whitespace-nowrap ${
                  scrolled ? "text-gray-700" : "text-white"
                }`}
              >
                {item.label}
              </a>
            ))}
          </nav>

          {/* Hamburger */}
          <button
            type="button"
            onClick={() => setMenuOpen(!menuOpen)}
            className={`lg:hidden w-10 h-10 rounded-lg flex flex-col items-center justify-center gap-1.5 transition-colors cursor-pointer ${
              scrolled || menuOpen ? "bg-gray-100" : "bg-white/20"
            }`}
            aria-label="メニュー"
          >
            <span className={`block w-5 h-0.5 transition-all duration-300 ${menuOpen ? "rotate-45 translate-y-2 bg-gray-800" : scrolled ? "bg-gray-800" : "bg-white"}`} />
            <span className={`block w-5 h-0.5 transition-all duration-300 ${menuOpen ? "opacity-0 bg-gray-800" : scrolled ? "bg-gray-800" : "bg-white"}`} />
            <span className={`block w-5 h-0.5 transition-all duration-300 ${menuOpen ? "-rotate-45 -translate-y-2 bg-gray-800" : scrolled ? "bg-gray-800" : "bg-white"}`} />
          </button>
        </div>
      </header>

      {/* Mobile menu */}
      <div
        className={`fixed inset-0 z-40 bg-green-700 transition-all duration-500 overflow-auto lg:hidden ${
          menuOpen ? "opacity-100 pointer-events-auto" : "opacity-0 pointer-events-none"
        }`}
      >
        <div className="flex items-center justify-between px-6 h-16">
          <div className="flex items-center gap-2 text-white">
            <div className="w-8 h-8 flex items-center justify-center">
              <i className="ri-leaf-line text-2xl" />
            </div>
            <div className="flex flex-col leading-none">
              <span className="text-xs font-semibold tracking-widest opacity-70">社会福祉法人</span>
              <span className="text-base font-bold tracking-wider">みどり苑</span>
            </div>
          </div>
          <button
            type="button"
            onClick={() => setMenuOpen(false)}
            className="w-10 h-10 rounded-lg bg-white/20 flex items-center justify-center cursor-pointer"
            aria-label="閉じる"
          >
            <i className="ri-close-line text-white text-xl" />
          </button>
        </div>

        <nav className="px-8 py-10 flex flex-col gap-6">
          {navItems.map((item) => (
            <a
              key={item.label}
              href={item.href}
              onClick={() => setMenuOpen(false)}
              className="text-white text-xl font-medium border-b border-white/20 pb-4 hover:opacity-80 transition-opacity"
            >
              {item.label}
            </a>
          ))}
          <div className="mt-4 border-t border-white/30 pt-6">
            <p className="text-white/70 text-xs font-semibold mb-2">代表電話</p>
            <a href="tel:0120-000-000" className="text-white text-3xl font-bold tracking-wider block">
              0120-000-000
            </a>
            <p className="text-white/80 text-sm mt-1">受付時間 9:00〜17:30</p>
          </div>
        </nav>
      </div>
    </>
  );
};

export default Header;
